import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 枚举服务
 */
export class EnumController {
    constructor() {
        this.baseurl = 'EnumController.assx/';
    }

    /**
     * 获取区划下的镇或者街道办
     * code:String, provinceCode:String, cityCode:String, areaCode:String, StartIndex:int, maxSize:int
     */
    getTownOrStreetOfArea(code, provinceCode, cityCode, areaCode, StartIndex, maxSize){
        return request.post(this.baseurl + 'getTownOrStreetOfArea', Qs.stringify({ code:code, provinceCode:provinceCode, cityCode:cityCode, areaCode:areaCode, StartIndex:StartIndex, maxSize:maxSize }));
    }

    /**
     * 获取所有省
     * keyName:String, valueName:String, StartIndex:int, maxSize:int
     */
    GetAllProvince(keyName, valueName, StartIndex, maxSize){
        return request.post(this.baseurl + 'GetAllProvince', Qs.stringify({ keyName:keyName, valueName:valueName, StartIndex:StartIndex, maxSize:maxSize }));
    }

    /**
     * 获取省下的市
     * code:String, provinceCode:String, StartIndex:int, maxSize:int
     */
    getCityOfProvince(code, provinceCode, StartIndex, maxSize){
        return request.post(this.baseurl + 'getCityOfProvince', Qs.stringify({ code:code, provinceCode:provinceCode, StartIndex:StartIndex, maxSize:maxSize }));
    }

    /**
     * 获取市下的区划
     * code:String, provinceCode:String, cityCode:String, StartIndex:int, maxSize:int
     */
    getAreaOfCity(code, provinceCode, cityCode, StartIndex, maxSize){
        return request.post(this.baseurl + 'getAreaOfCity', Qs.stringify({ code:code, provinceCode:provinceCode, cityCode:cityCode, StartIndex:StartIndex, maxSize:maxSize }));
    }

    /**
     * 获取指定枚举所有映射值 
     * enumName:String, isDesc:boolean
     */
    getEnum(enumName, isDesc){
        return request.post(this.baseurl + 'getEnum', Qs.stringify({ enumName:enumName, isDesc:isDesc }));
    }

    /**
     * 获取考评试题类型
     * keyName:String, valueName:String
     */
    GetExamineQuestionTypeEnum(keyName, valueName){
        return request.post(this.baseurl + 'GetExamineQuestionTypeEnum', Qs.stringify({ keyName:keyName, valueName:valueName }));
    }

    /**
     * 获取问题 计分策略枚举
     * keyName:String, valueName:String
     */
    GetPolicyEnumOfAnswer(keyName, valueName){
        return request.post(this.baseurl + 'GetPolicyEnumOfAnswer', Qs.stringify({ keyName:keyName, valueName:valueName }));
    }

    /**
     * 获取指定枚举所有映射值 自定义键值对名称
     * enumName:String, isDesc:boolean, keyName:String, valueName:String
     */
    getEnumDefineBySelf(enumName, isDesc, keyName, valueName){
        return request.post(this.baseurl + 'getEnumDefineBySelf', Qs.stringify({ enumName:enumName, isDesc:isDesc, keyName:keyName, valueName:valueName }));
    }

    /**
     * 获取父级试题 计分策略枚举
     * keyName:String, valueName:String, isAnswer:boolean
     */
    GetPolicyEnum(keyName, valueName, isAnswer){
        return request.post(this.baseurl + 'GetPolicyEnum', Qs.stringify({ keyName:keyName, valueName:valueName, isAnswer:isAnswer }));
    }

    /**
     * 获取指定枚举所有映射值 的 分页。isDesc 是否倒序排列 
     * enumName:String, isDesc:boolean, startIndex:int, maxSize:int
     */
    getEnumPage(enumName, isDesc, startIndex, maxSize){
        return request.post(this.baseurl + 'getEnumPage', Qs.stringify({ enumName:enumName, isDesc:isDesc, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 获取父级试题 计分策略枚举
     * keyName:String, valueName:String
     */
    GetPolicyEnumOfQuestion(keyName, valueName){
        return request.post(this.baseurl + 'GetPolicyEnumOfQuestion', Qs.stringify({ keyName:keyName, valueName:valueName }));
    }
}